import React, { useEffect } from 'react';
import Rodape from '../../components/Rodape';
import Navegador from '../../components/NavBar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import background from '../../assets/imgs/capa1.png';


import './styles.scss';

const LGPD = () => {



    useEffect(() => {


    }, []);

    return (
        <div className="container-fluid"  >
            <div style={{
                backgroundImage: `url(${background})`,
                backgroundSize: "cover",


            }} >


                <Navegador />
                <div style={{ height: 5, backgroundColor: '#808080' }}>
                </div>

                <div style={{ backgroundColor: 'white', color: 'black' }}>

                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        item xs={12} sm={12} md={12} lg={12} xl={12}
                        style={{ paddingTop: 80, paddingBottom: 80 }}
                    >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ textAlign: "center" }} >
                            <Typography component="h1" variant="h5" >
                                <span style={{ fontSize: 28, fontWeight: 'bold' }}> Política de Privacidade</span><br></br> <br></br>
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            item xs={12} sm={12} md={12} lg={12} xl={12}
                        >

                            <Grid item xs={12} sm={12} md={12} lg={2} xl={2} style={{ textAlign: "center" }} >

                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={8} xl={8} style={{ textAlign: "justify" }} >
                                <Typography component="h1" variant="h5" >
                                    Introdução
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                        Na LD Armazéns, privacidade e segurança são prioridades e nos comprometemos com a transparência do tratamento de dados pessoais dos nossos usuários/clientes. Por isso, esta presente Política de Privacidade estabelece como é feita a coleta, uso e transferência de informações de clientes ou outras pessoas que acessam ou usam nosso site.

                                        Ao utilizar nossos serviços, você entende que coletaremos e usaremos suas informações pessoais nas formas descritas nesta Política, sob as normas da Constituição Federal de 1988 (art. 5º, LXXIX; e o art. 22º, XXX – incluídos pela EC 115/2022), das normas de Proteção de Dados (LGPD, Lei Federal 13.709/2018), das disposições consumeristas da Lei Federal 8078/1990 e as demais normas do ordenamento jurídico brasileiro aplicáveis.

                                        Dessa forma, a LD Armazéns, doravante denominada simplesmente como “LD Armazéns Gerais”, inscrita no CNPJ/MF sob o nº 24.986.679/0001-06, no papel de Controladora de Dados, obriga-se ao disposto na presente Política de Privacidade.
                                    </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                    1. Quais dados coletamos sobre você e para qual finalidade?
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                        Nosso site coleta e utiliza alguns dados pessoais seus, de forma a viabilizar a prestação de serviços e aprimorar a experiência de uso.
                                    </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                    1.1. Dados pessoais fornecidos pelo titular
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                        Nome com finalidade de identificar quem nós envia formulários de contato
                                        <br></br>
                                        E-mail com finalidade de identificar quem nós envia formulários de contato
                                        <br></br>
                                        Telefone com finalidade de identificar quem nós envia formulários de contato
                                       </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                    2. Como coletamos os seus dados?
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                        Nesse sentido, a coleta dos seus dados pessoais ocorre da seguinte forma:
                                        <br></br>
                                        Nome é coletado ao usuário inserir-lo no campo Nome na página
                                        de contato, no formulário de contato.
                                        
                                        <br></br>
                                        E-mail é coletado ao usuário inserir-lo no campo Nome na página
                                        de contato, no formulário de contato.
                                        <br></br>
                                        Telefone é coletado ao usuário inserir-lo no campo Nome na página
                                        de contato, no formulário de contato.
                                       
                                    </span><br></br> <br></br>
                                </Typography>


                                <Typography component="h1" variant="h5" >
                                2.1. Consentimento
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    É a partir do seu consentimento que tratamos os seus dados pessoais. O consentimento é a manifestação livre, informada e inequívoca pela qual você autoriza a (nome empresarial simplificado) a tratar seus dados.

Assim, em consonância com a Lei Geral de Proteção de Dados, seus dados só serão coletados, tratados e armazenados mediante prévio e expresso consentimento. 

O seu consentimento será obtido de forma específica para cada finalidade acima descrita, evidenciando o compromisso de transparência e boa-fé da (nome empresarial simplificado) para com seus usuários/clientes, seguindo as regulações legislativas pertinentes.

Ao utilizar os serviços da (nome empresarial simplificado) e fornecer seus dados pessoais, você está ciente e consentindo com as disposições desta Política de Privacidade, além de conhecer seus direitos e como exercê-los.

A qualquer tempo e sem nenhum custo, você poderá revogar seu consentimento.

É importante destacar que a revogação do consentimento para o tratamento dos dados pode implicar a impossibilidade da performance adequada de alguma funcionalidade do site que dependa da operação. Tais consequências serão informadas previamente.
                                    </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                3. Quais são os seus direitos?
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    A  LD Armazéns assegura a seus usuários/clientes seus direitos de titular previstos no artigo 18 da Lei Geral de Proteção de Dados. Dessa forma, você pode, de maneira gratuita e a qualquer tempo:

Confirmar a existência de tratamento de dados, de maneira simplificada ou em formato claro e completo.
Acessar seus dados, podendo solicitá-los em uma cópia legível sob forma impressa ou por meio eletrônico, seguro e idôneo.
Corrigir seus dados, ao solicitar a edição, correção ou atualização destes.
Limitar seus dados quando desnecessários, excessivos ou tratados em desconformidade com a legislação através da anonimização, bloqueio ou eliminação.
Solicitar a portabilidade de seus dados, através de um relatório de dados cadastrais que a LD Armazéns trata a seu respeito.
Eliminar seus dados tratados a partir de seu consentimento, exceto nos casos previstos em lei.
Revogar seu consentimento, desautorizando o tratamento de seus dados.
Informar-se sobre a possibilidade de não fornecer seu consentimento e sobre as consequências da negativa.
                                   </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                4. Como você pode exercer seus direitos de titular?
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    Para exercer seus direitos de titular, você deve entrar em contato com a (nome empresarial simplificado) através dos seguintes meios disponíveis:  <br></br>

(38) 9 9941-6698  <br></br>  <br></br>
De forma a garantir a sua correta identificação como titular dos dados pessoais objeto da solicitação, é possível que solicitemos documentos ou demais comprovações que possam comprovar sua identidade. Nessa hipótese, você será informado previamente.</span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                5. Como e por quanto tempo seus dados serão armazenados?
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    Seus dados pessoais coletados pela (nome empresarial simplificado) serão utilizados e armazenados durante o tempo necessário para a prestação do serviço ou para que as finalidades elencadas na presente Política de Privacidade sejam atingidas, considerando os direitos dos titulares dos dados e dos controladores.

De modo geral, seus dados serão mantidos enquanto a relação contratual entre você e a (nome empresarial simplificado) perdurar. Findado o período de armazenamento dos dados pessoais, estes serão excluídos de nossas bases de dados ou anonimizados, ressalvadas as hipóteses legalmente previstas no artigo 16 lei geral de proteção de dados, a saber:

I – cumprimento de obrigação legal ou regulatória pelo controlador;

II – estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais;

III – transferência a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos nesta Lei; ou

IV – uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados os dados.

Isto é, informações pessoais sobre você que sejam imprescindíveis para o cumprimento de determinações legais, judiciais e administrativas e/ou para o exercício do direito de defesa em processos judiciais e administrativos serão mantidas, a despeito da exclusão dos demais dados. 

O armazenamento de dados coletados pela (nome empresarial simplificado) reflete o nosso compromisso com a segurança e privacidade dos seus dados. Empregamos medidas e soluções técnicas de proteção aptas a garantir a confidencialidade, integridade e inviolabilidade dos seus dados. Além disso, também contamos com medidas de segurança apropriadas aos riscos e com controle de acesso às informações armazenadas.
                                   </span><br></br> <br></br>
                                </Typography>


                                <Typography component="h1" variant="h5" >
                                6. O que fazemos para manter seus dados seguros?
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    Para mantermos suas informações pessoais seguras, usamos ferramentas físicas, eletrônicas e gerenciais orientadas para a proteção da sua privacidade.

Aplicamos essas ferramentas levando em consideração a natureza dos dados pessoais coletados, o contexto e a finalidade do tratamento e os riscos que eventuais violações gerariam para os direitos e liberdades do titular dos dados coletados e tratados.

Entre as medidas que adotamos, destacamos as seguintes:

Apenas pessoas autorizadas têm acesso a seus dados pessoais
O acesso a seus dados pessoais é feito somente após o compromisso de confidencialidade
Seus dados pessoais são armazenados em ambiente seguro e idôneo.
A (nome empresarial simplificado) se compromete a adotar as melhores posturas para evitar incidentes de segurança. Contudo, é necessário destacar que nenhuma página virtual é inteiramente segura e livre de riscos. É possível que, apesar de todos os nossos protocolos de segurança, problemas de culpa exclusivamente de terceiros ocorram, como ataques cibernéticos de hackers, ou também em decorrência da negligência ou imprudência do próprio usuário/cliente.

Em caso de incidentes de segurança que possa gerar risco ou dano relevante para você ou qualquer um de nossos usuários/clientes, comunicaremos aos afetados e a Autoridade Nacional de Proteção de Dados sobre o ocorrido, em consonância com as disposições da Lei Geral de Proteção de Dados.
                                   </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                7. Com quem seus dados podem ser compartilhados?
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    Tendo em vista a preservação de sua privacidade, a (nome empresarial simplificado) não compartilhará seus dados pessoais com nenhum terceiro não autorizado. 

Seus dados poderão ser compartilhados com nossos parceiros comerciais: (nome completo ou empresarial do parceiro comercial), inscrito no CPF/CNPJ sob o nº (número do CPF Ou CNPJ do parceiro comercial).

Estes recebem seus dados apenas na medida do necessário para a prestação dos serviços contratados e nossos contratos são orientados pelas normas de proteção de dados do ordenamento jurídico brasileiro.

Todavia, nossos parceiros têm suas próprias Políticas de Privacidade, que podem divergir desta. Recomendamos a leitura desses documentos, que você pode acessar aqui:

Política de Privacidade do nosso parceiro: (link para a política de privacidade do parceiro comercial).

Além disso, também existem outras hipóteses em que seus dados poderão ser compartilhados, que são:

I – Determinação legal, requerimento, requisição ou ordem judicial, com autoridades judiciais, administrativas ou governamentais competentes.

II – Caso de movimentações societárias, como fusão, aquisição e incorporação, de forma automática

III – Proteção dos direitos da (nome empresarial simplificado) em qualquer tipo de conflito, inclusive os de teor judicial.
                                   </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                7.1. Transferência internacional de dados
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    Alguns dos terceiros com quem compartilhamos seus dados podem ser localizados ou ou possuir instalações localizadas em países estrangeiros. Nessas condições, de toda forma, seus dados pessoais estarão sujeitos à Lei Geral de Proteção de Dados e às demais legislações brasileiras de proteção de dados

Nesse sentido, a (nome empresarial simplificado) se compromete a sempre adotar eficientes padrões de segurança cibernética e de proteção de dados, nos melhores esforços de garantir e cumprir as exigências legislativas.

Ao concordar com essa Política de Privacidade, você concorda com esse compartilhamento, que se dará conforme as finalidades descritas no presente instrumento.
                                   </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                8. Cookies ou dados de navegação
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    A LD Armazéns faz uso de Cookies, que são arquivos de texto enviados pela plataforma ao seu computador e que nele se armazenam, que contém informações relacionadas à navegação do site. Em suma, os Cookies são utilizados para aprimorar a experiência de uso.

Ao acessar nosso site e consentir com o uso de Cookies, você manifesta conhecer e aceitar a utilização de um sistema de coleta de dados de navegação com o uso de Cookies em seu dispositivo.

A LD Armazéns utiliza os seguintes Cookies: (id_usuario, usuario).

Você pode, a qualquer tempo e sem nenhum custo, alterar as permissões, bloquear ou recusar os Cookies. Todavia, a revogação do consentimento de determinados Cookies pode inviabilizar o funcionamento correto de alguns recursos da plataforma.
                                   </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                9. Alteração desta Política de Privacidade
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    A atual versão da Política de Privacidade foi formulada e atualizada pela última vez em: (data da última atualização da Política de Privacidade).

Reservamos o direito de modificar essa Política de Privacidade a qualquer tempo, principalmente em função da adequação a eventuais alterações feitas em nosso site ou em âmbito legislativo. Recomendamos que você a revise com frequência.

Eventuais alterações entrarão em vigor a partir de sua publicação em nosso site e sempre lhe notificaremos acerca das mudanças ocorridas.

Ao utilizar nossos serviços e fornecer seus dados pessoais após tais modificações, você as consente. 
                                   </span><br></br> <br></br>
                                </Typography>


                                <Typography component="h1" variant="h5" >
                                10. Responsabilidade
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    A LD Armazéns prevê a responsabilidade dos agentes que atuam nos processos de tratamento de dados, em conformidade com os artigos 42 ao 45 da Lei Geral de Proteção de Dados.

Nos comprometemos em manter esta Política de Privacidade atualizada, observando suas disposições e zelando por seu cumprimento.

Além disso, também assumimos o compromisso de buscar condições técnicas e organizativas seguramente aptas a proteger todo o processo de tratamento de dados.

Caso a Autoridade Nacional de Proteção de Dados exija a adoção de providências em relação ao tratamento de dados realizado pela LD Armazéns, comprometemo-nos a segui-las. 
                                 </span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                10.1 Isenção de responsabilidade
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                    Conforme mencionado no Tópico 6, embora adotemos elevados padrões de segurança a fim de evitar incidentes, não há nenhuma página virtual inteiramente livre de riscos. Nesse sentido, a LD Armazéns não se responsabiliza por:

I – Quaisquer consequências decorrentes da negligência, imprudência ou imperícia dos usuários em relação a seus dados individuais. Garantimos e nos responsabilizamos apenas pela segurança dos processos de tratamento de dados e do cumprimento das finalidades descritas no presente instrumento.

Destacamos que a responsabilidade em relação à confidencialidade dos dados de acesso é do usuário.

II – Ações maliciosas de terceiros, como ataques de hackers, exceto se comprovada conduta culposa ou deliberada da LD Armazéns.

Destacamos que em caso de incidentes de segurança que possam gerar risco ou dano relevante para você ou qualquer um de nossos usuários/clientes, comunicaremos aos afetados e a Autoridade Nacional de Proteção de Dados sobre o ocorrido e cumpriremos as providências necessárias.

III – Inveracidade das informações inseridas pelo usuário/cliente nos registros necessários para a utilização dos serviços da LD Armazéns; quaisquer consequências decorrentes de informações falsas ou inseridas de má-fé são de inteiramente responsabilidade do usuário/cliente.</span><br></br> <br></br>
                                </Typography>

                                <Typography component="h1" variant="h5" >
                                11. Encarregado de Proteção de Dados
                                </Typography>
                                <Typography component="h1" variant="h5" >
                                    <br></br>
                                    <span style={{ fontSize: 14 }}>
                                 
                                    A LD Armazéns disponibiliza os seguintes meios para que você possa entrar em contato conosco para exercer seus direitos de titular: (meios de contato).

Caso tenha dúvidas sobre esta Política de Privacidade ou sobre os dados pessoais que tratamos, você pode entrar em contato com o nosso Encarregado de Proteção de Dados Pessoais, através dos seguintes canais:

[Aislan Silva Costa (120.927.986-00)]

[comprasaislan@gmail.com]
                                 </span><br></br> <br></br>
                                
                                </Typography>

                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={2} xl={2} style={{ textAlign: "center" }} >

                            </Grid>

                        </Grid>

                    </Grid>
                </div>



                <div style={{ height: 5, backgroundColor: 'green' }}>
                </div>



            </div>

            <div >
                <Rodape />
            </div>
        </div >
    );
}


export default LGPD;
